










































import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class AlarmSelect extends Vue {
  @Prop() public data!: any;
  @Prop() public value!: any;
  @Prop() public title!: string;
  @Prop({default: false}) public hasSearch!: boolean;
  public search: string = '';
  public visible: boolean = false;
  get filterData() {
    return this.data.filter((i: any) => i.label.toUpperCase().indexOf(this.search.toUpperCase()) !== -1);
  }
  public handleOpen() {
    this.visible = true;
  }
  public handleSelect(i: any) {
    this.$emit('input', i);
    this.visible = false;
  }
}
